import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { debug as d } from "debug";
import AudioPlayer from "../audio-player.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'listen-activity',
  props: {
    activityId: {},
    mandatory: { type: Boolean },
    cmsAudioSrc: {},
    complete: { type: Boolean, default: false },
    trackTitle: {},
    albumTitle: {}
  },
  emits: ["activity-completed"],
  setup(__props: any, { emit: __emit }) {

const debug = d("cs.ListenActivityComponent");

const props = __props;

const emit = __emit;

const audioId = computed(() => props.activityId);

const onListenEnd = () => {
  debug("onListenEnd");
  if (!props.complete) {
    debug("Completing listening activity");
    emit("activity-completed", props.activityId);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["activity listen-activity activity-with-button", { mandatory: _ctx.mandatory, complete: _ctx.complete }])
  }, [
    _createVNode(AudioPlayer, {
      "audio-id": audioId.value,
      "cms-audio-src": _ctx.cmsAudioSrc,
      "track-title": _ctx.trackTitle,
      "album-title": _ctx.albumTitle,
      "on-listen-end": onListenEnd,
      "is-complete": _ctx.complete
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["audio-id", "cms-audio-src", "track-title", "album-title", "is-complete"])
  ], 2))
}
}

})